import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(ScrollTrigger, TextPlugin);

// 横書き
export function Typing(targetSelector = ".js-typing-effect", charSpeed = 0.05) {
  const typeTextEls = document.querySelectorAll(targetSelector);

  typeTextEls.forEach((el) => {
    const sourceText = el.textContent;

    // 初期化
    gsap.set(el, {
      text: {
        value: "",
      },
    });

    const tl = gsap.timeline({ paused: true });
    const customDelay = el.hasAttribute("data-delay")
      ? parseFloat(el.dataset.delay)
      : 0.05;

    tl.add(() => {
      el.classList.add("is-start");
    }, +customDelay)
      .add(() => {
        gsap.set(el, {
          text: {
            newClass: "cursor-caret",
          },
        });
      })
      .to(el, {
        duration: sourceText.length * charSpeed,
        text: {
          value: sourceText,
          newClass: "cursor-caret",
          delimiter: "",
        },
        ease: "sine.Out",
      })
      .add(() => {
        el.querySelector(".cursor-caret")?.removeAttribute("class");
      }, "+=0.1")
      .add(() => {
        el.classList.add("is-end");
      }, "+=0.1");

    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      onEnter: () => tl.play(),
      once: true,
    });
  });
}

// 縦書き
export function TypingVertical(
  targetSelector = ".js-typing-vertical-effect",
  charSpeed = 0.05,
) {
  const typeTextElslr = document.querySelectorAll(targetSelector);
  typeTextElslr.forEach((el) => {
    // テキスト内容を保存
    const sourceText = el.textContent;

    // テキストを空に設定
    gsap.set(el, {
      text: {
        value: "",
      },
    });

    // タイムラインの設定
    const tl = gsap.timeline({ paused: true });
    const customDelay = el.hasAttribute("data-delay")
      ? parseFloat(el.dataset.delay)
      : 0.2;

    tl.add(() => {
      gsap.set(el, {
        text: {
          newClass: "cursor-caret",
        },
      });
    }, "+=0.2")
      .to(el, {
        delay: customDelay,
        duration: sourceText.length * charSpeed,
        text: {
          value: sourceText, // 保存したテキスト内容を設定
          newClass: "cursor-caret-rl",
          delimiter: "",
        },
        ease: "sine.Out",
      })
      // 終了後にカーソル非表示とクラス追加
      .add(() => {
        el.classList.add("is-end");
      }, "+=0.1")
      .add(() => {
        el.querySelector(".cursor-caret-rl")?.removeAttribute("class");
      }, "+=0.1");

    // スクロールトリガーの設定
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      onEnter: () => tl.play(),
      once: true,
    });
  });
}
